import {
    archiveFulfilledConstants,
    archiveRejectedConstants,
    archivePendingConstants,
    devicesFulfilledConstants,
    devicesPendingConstants,
    devicesRejectedConstants
} from '../actions';

export const initialState = {
    items: [],
    total: 0,
    error: '',
    isLoading: true
};

export default function (state = initialState, action) {
    switch (action.type) {
        case archiveFulfilledConstants.ARCHIVE_LOADED:
            return {
                items: action.payload.items,
                total: action.payload.total,
                isLoading: true
            };
        case archiveFulfilledConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_ATTRIBUTE:
        case archiveFulfilledConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_VERSION:
        case archiveFulfilledConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_NAME:
        case archiveFulfilledConstants.ARCHIVE_RESTORE_DEVICE: {
            return state;
        }
        case archiveRejectedConstants.ARCHIVE_LOADED:
        case archiveRejectedConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_ATTRIBUTE:
        case archiveRejectedConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_VERSION:
        case archiveRejectedConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_NAME:
        case archiveRejectedConstants.ARCHIVE_RESTORE_DEVICE: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...initialState,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...initialState,
                    error: error.message
                };
            }

            return state;
        }
        case devicesFulfilledConstants.DEVICE_PROFILE_INFO_LOADED:
            const { data, deviceId } = action.payload;
            return {
                ...state,
                items: state.items.map(item => (item.id === deviceId ? { ...item, profileData: data, isLoading: false, error: '' } : item)),
            };
        case archivePendingConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_ATTRIBUTE:
        case archivePendingConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_VERSION:
        case archivePendingConstants.ARCHIVE_RESTORE_LICENSE_PRODUCT_NAME:
        case archivePendingConstants.ARCHIVE_RESTORE_DEVICE:
            return {
                ...state,
                isLoading: false
            };
        case devicesPendingConstants.DEVICE_PROFILE_INFO_LOADED:
            return {
                ...state,
                items: state.items.map(item => (item.id === action.meta ? { ...item, profileData: { isLoading: true, error: '' } } : item)),
            };
        case devicesRejectedConstants.DEVICE_PROFILE_INFO_LOADED:
            const error = action.payload;

            return {
                ...state,
                items: state.items.map(item =>
                    (item.id === action.meta
                        ? { ...item, profileData: { isLoading: false, error: error.message } }
                        : item
                    )),
            };
        default:
            return state;
    }
}
